import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";
import { api } from "@/lib/api";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    // 1. Respect explicit user choice (from localStorage)
    const stored = localStorage.getItem("wb_lang");
    if (stored) return stored;
    // 2. Auto-detect from browser language on first visit
    const supported = ["sk", "en", "cs", "de", "pl", "fr"];
    const nav = (navigator.language || navigator.userLanguage || "sk").toLowerCase();
    const primary = nav.split("-")[0]; // "en-US" → "en"
    return supported.includes(primary) ? primary : "en";
  });
  useEffect(() => {
    localStorage.setItem("wb_lang", lang);
    // Best-effort sync to backend (for email language preference). Only fires if logged in.
    if (localStorage.getItem("wb_token")) {
      api.post("/auth/lang", { lang }).catch(() => {});
    }
  }, [lang]);
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
